export class LineRunLocationFilter {
    public IncludeInactive?: boolean;
}

export default LineRunLocationFilter;